<template>
  <div style="width: 100%;height:100%;padding:20px;">
    <h1 class="P1">
      <a id="a__服务条款"><span /></a><span class="T1">服务条款</span
      ><a id="_GoBack" />
    </h1>
    <p class="Standard">更新于2022年5月11日</p>
    <p class="Standard">
      特别提示：在启动Loop的任何训练课程前，请先咨询健康专家您的身体状况是否适合参加此种训练以及该训练课程是否能够满足您的个人需求，因参加任何训练课程而引起的一切风险、损害及责任等，由您自行承担。
    </p>
    <p class="Standard">
      加加互动（厦门）体育产业有限公司（含其关联公司，以下称“加加”或“我们”）为Loop
      App（以下称“Loop”或“本站”）的实际开发者和运营者。Loop是一款社交型跳绳App，用户可以随时跟随Loop的视频课程进行训练，还可以在Loop社区与其他用户就跳绳知识及跳绳问题进行沟通、交流。本服务条款构成我们与Loop用户（以下称“用户”或“您”）之间就Loop
      App提供的上述服务等事宜订立的契约，请仔细阅读本服务条款。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      您访问本站，下载Loop
      App并注册成为Loop用户后，则即表示您同意接受本服务条款的约束，而本服务条款即构成对双方具有约束力的法律文件。
    </p>
    <p class="Standard">1.服务条款的确认及接受</p>
    <p class="Standard">
      1.1
      本站的各项电子服务的所有权和运作权归加加所有。您同意服务条款及隐私条款并完成注册程序后，即成为Loop的正式用户。用户确认：本服务条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      1.2
      您点击同意本服务条款，即视为您确认自己已具有与享受本站提供的课程训练、下单购物等服务相对应的权利能力和行为能力，并能够独立承担法律责任。
    </p>
    <p class="Standard">
      1.3
      如果您未满18周岁，您只能在父母或监护人的监护参与下才能使用本站的课程服务或下单购物等。
    </p>
    <p class="Standard">
      1.4
      加加保留在中华人民共和国大陆地区法现行法律法规允许的范围内自行决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单等的权利。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      1.5
      本站的软件著作权及App上发布的所有信息与内容的版权均受中华人民共和国著作权法（含相关法律、法规）乃至世界版权法律的保护，仅供用户因自身学习、调研等目的免费使用。严禁未经授权对本站内容进行复制、发行、出租、展览、放映、广播、修改、演绎、翻译、汇编、改编或逆向工程。加加互动（厦门）体育产业有限公司保留所有未在本服务条款中明确授予的权利。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      1.6
      加加通过互联网依法为用户提供互联网信息等服务，您在完全同意本服务条款及本站其他规定（包括但不限于隐私条款、社区公约、社区规范、训练提示、退换货政策等在本站发布的所有规则及政策）的情况下，方有权使用本站的相关服务
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      1.7
      用户必须自行准备如下设备并承担如下开支：（1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网设备；（2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">2. Loop账号注册规则</p>
    <p class="Standard">
      2.1
      Loop账号注册资料包括但不限于用户的账号名称、头像、密码、注册或更新账号时输入的所有信息以及您在Loop商城进行购物时所填写的所有信息（包括但不限于收货人姓名、地址、联系电话等）。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      2.2
      在注册Loop账号时，用户应承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，且保证在注册及使用Loop账号时，不得有以下情形：
    </p>
    <p class="Standard">（1）违反宪法或法律法规规定的；</p>
    <p class="Standard">
      （2）危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的；
    </p>
    <p class="Standard">（3）损害国家荣誉和利益的，损害公共利益的；</p>
    <p class="Standard">（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="Standard">（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p class="Standard">（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p class="Standard">
      （7）散步淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
    </p>
    <p class="Standard">（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p class="Standard">
      （9）含有法律、行政法规禁止的其他内容或违反Loop的其他规定的。
    </p>
    <p class="Standard">
      2.3
      用户应保证其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新。因用户提供的注册资料不符合本条款约定而引起的一切责任及后果（包括但不限于不予注册、账户停用或注销等），由用户自行承担，且加加保留终止用户使用Loop各项服务的权利。
    </p>
    <p class="Standard">
      2.4
      用户以虚假信息骗取账号名称注册，或其账号头像、简介等注册信息存在违法和不良信息的，加加有权采取通知限期改正、暂停使用、注销登记等措施。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      2.5
      对冒用、关联机构或社会名人注册账号名称的用户，加加有权注销其账号，并向互联网信息内容主管部门报告。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      2.6
      用户在使用本站服务或下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露。
    </p>
    <p class="Standard">
      2.7
      用户成功注册后，将产生用户名和密码等账户信息，您可以根据本站规定更改您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。因用户未妥善保管其账户名称及密码而导致第三人使用账户而给用户造成的损失，由用户自行承担。
    </p>
    <p class="Standard"> </p>
    <p class="Standard">
      2.8
      您的Loop账户仅限于您自己使用，严禁将您的Loop账户允许第三人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任
    </p>
    <p class="Standard">
      2.9
      依据相关法律法规的规定，加加有权对注册用户进行基于移动电话号码、电子邮箱、微信等真实身份信息认证。对于拒绝进行真实身份信息认证的用户，加加保留拒绝此用户使用Loop相关服务的权利并有权对用户进行包括但不限于限制服务使用、关闭账号等的处理。
    </p>
    <p class="Standard">3.用户管理</p>
    <p class="Standard">
      3.1
      用户必须遵守中华人民共和国及国际相关法律法规的规定，独立对其发布的内容（包括但不限于文字、图片等）承担责任。用户承诺：
    </p>
    <p class="Standard">
      （1）用户在使用我们提供的服务或在本站发布信息时必须符合中华人民共和国相关法律法规的规定，不得在本站制作、复制、发布、传播以下内容或信息：
    </p>
    <p class="Standard">(a) 违反宪法确定的基本原则的；</p>
    <p class="Standard">
      (b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
    </p>
    <p class="Standard">(c) 损害国家荣誉和利益的；</p>
    <p class="Standard">(d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
    <p class="Standard">(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p class="Standard">(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p class="Standard">(g) 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
    <p class="Standard">(h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
    <p class="Standard">
      (i) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
    </p>
    <p class="Standard">(j) 以非法民间组织名义活动的；</p>
    <p class="Standard">
      (k) 含有法律、行政法规禁止的其他内容或违反Loop的其他规定的。
    </p>
    <p class="Standard">
      （2）用户在使用我们提供的服务或在本站发布信息时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。
    </p>
    <p class="Standard">
      3.2
      用户理解并同意，其在本站发布的任何信息（包括但不限于文字、图片等），均已自动授权加加或Loop在包含宣传推广在内的各个合法途径使用。若用户对加加或Loop使用信息的方式存在异议，应在发现后及时联系加加或Loop进行沟通解决，若用户未对加加或Loop的使用行为提出异议，则默认其同意此种使用行为且无权就上述使用主张权利。
    </p>
    <p class="Standard">
      3.3
      用户不得以任何方式干扰Loop服务且不得通过本站发布任何形式的广告，Loop对用户发布的广告内容有权进行包括但不限于删除内容直至关闭账号的处理。因网络信息传播在时间上的即时性及空间上的广泛性，我们不可能在第一时间对用户发布广告的行为进行处理，在此提请用户需对此种广告的内容自行甄别，因用户受此种广告内容的影响而产生的任何损失，均与加加或Loop无关。Loop鼓励用户对上述广告发布行为进行举报，我们会在收到举报后及时处理。
    </p>
    <p class="Standard">3.4 责任承担</p>
    <p class="Standard">
      （1）用户须对自己在使用Loop服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在加加公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予加加公司等额的赔偿。若用户违反以上规定，我们有权作出独立判断立即暂停或终止对用户提供部分或全部服务，包括锁定、注销、删除用户Loop账号等措施。
    </p>
    <p class="Standard">
      （2）用户理解，如果Loop发现其发布的信息明显属于本条第（1）款所列内容之一，依据中华人民共和国现行相关法律，本站有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。
    </p>
    <p class="Standard">4.用户隐私制度</p>
    <p class="Standard">
      4.1
      用户知悉并同意，为了记录用户训练的真实数据以及在电商功能下给用户提供配送等相关服务，我们在您自愿的前提下收集您的个人信息并将这些信息进行整合，包括但不限于注册账号时的相关信息、个人身体数据（身高、体重、健康数据等）、GPS定位数据、收货人的姓名、地址、电话等。
    </p>
    <p class="Standard">
      4.2
      尊重用户个人隐私是Loop的一项基本政策。所以，Loop不会公开或向任何第三方透露用户的注册资料以及用户因享受Loop服务而提供的任何信息，但以下情形除外：
    </p>
    <p class="Standard">（1）事先获得用户的明确授权或许可；</p>
    <p class="Standard">
      （2）遵守有关法律规定，包括在国家有关机关查询时，提供用户的注册信息、用户在本站发布的信息内容及其发布时间、互联网地址或者域名等；
    </p>
    <p class="Standard">
      （3）在紧急情况下竭力维护用户个人和社会大众的隐私安全；
    </p>
    <p class="Standard">（4）根据本条款相关规定或者Loop认为必要的其他情形。</p>
    <p class="Standard">
      Loop可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与Loop同等的保护用户隐私的责任，则Loop可将用户信息提供给该第三方。
    </p>
    <p class="Standard">6.所有权及知识产权条款</p>
    <p class="Standard">
      6.1
      用户一旦接受本服务条款，即表明该用户主动将其在本站发表的任何形式的信息内容（包括但不限于用户评论、用户咨询、各类话题文章、训练图片等）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利）等，全部独家且不可撤销地转让给加加所有，用户同意加加有权就任何主体侵权而单独提起诉讼。
    </p>
    <p class="Standard">
      6.2
      本服务条款已经构成《中华人民共和国著作权法》第二十五条及相关法律规定的著作财产权等权利转让的书面协议，其效力及于用户在本站发布的任何受著作权法保护的作品内容，无论该等内容形成于本服务条款订立前还是订立后。
    </p>
    <p class="Standard">
      6.3
      用户同意并已充分了解本条款的含义，承诺不将已发表于本站的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。
    </p>
    <p class="Standard">
      6.4 加加（含其关联企业）是Loop App的所有者及运营者，拥有Loop
      App内容、资源及软件的著作权等合法权利，受国家法律保护，有权不时地对本服务条款、Loop
      App版本及内容进行修改或更新，并在App内张贴或直接更新，无须另行通知用户。在法律允许的最大限度范围内，加加（含其关联企业）对本条款及Loop
      App内容拥有解释权。
    </p>
    <p class="Standard">
      6.5
      除法律另有强制性规定外，未经加加（含其关联企业）明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本站及Loop
      App内的信息内容，否则，加加有权追究其法律责任。
    </p>
    <p class="Standard">
      6.6 本站及Loop
      App内所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、
      数字下载、数据编辑和软件），均是加加或其内容提供者的财产，受中华人民共和国和国际版权法及相关法律法规的保护；上述内容的汇编是加加的排他财产，受中华人民共和国和国际版权法及相关法律法规的保护；本站上所有软件都是加加（含其关联公司）的财产，受中华人民共和国和国际版权法及相关法律法规的保护。
    </p>
    <p class="Standard" />
    <p class="Standard">7.责任限制及不承诺担保</p>
    <p class="Standard">
      7.1
      除非另有明确的书面说明，本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在”按现状”和”按现有”的基础上提供的。
    </p>
    <p class="Standard">
      7.2
      除非另有明确的书面说明，我们不对本站的运营及其包含在本站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
    </p>
    <p class="Standard">
      7.3
      我们不担保本站所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、
    </p>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  mounted() {},
};
</script>

<style type="text/css">
@page {
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
}

td,
th {
  vertical-align: top;
  font-size: 12pt;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  clear: both;
}

ol,
ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* "li span.odfLiEnd" - IE 7 issue*/
li span {
  clear: both;
  line-height: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

span.footnodeNumber {
  padding-right: 1em;
}

span.annotation_style_by_filter {
  font-size: 95%;
  font-family: Arial;
  background-color: #fff000;
  margin: 0;
  border: 0;
  padding: 0;
}

span.heading_numbering {
  margin-right: 0.8rem;
}

* {
  margin: 0;
}

.P1 {
  font-size: 22pt;
  font-weight: bold;
  line-height: 240%;
  margin-bottom: 0.2291in;
  margin-top: 0.2362in;
  text-align: center !important;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
}

.Standard {
  font-size: 14pt;
  font-family: Calibri;
  writing-mode: horizontal-tb;
  direction: ltr;
  text-align: justify !important;
}
</style>